import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import mainimage from "../Asserts/mainimage.png";
import { FaArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

const slides = [
  {
    title: "Smart Solutions for Your Better Future",
    text: "We understand that finding the right financial partner is critical to your business growth. That's why we offer a range of financial solutions that are tailored to your business needs.",
    image: mainimage,
  },
];

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const handleAboutClick = () => {
    navigate('/contact');
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-gradient-to-r from-[#f4f1de] to-[#FDFBF8]  flex flex-col items-center justify-center  md:min-h-0">
      <Helmet>
        <title>Kota HOLDINGS</title>
        <meta name="description" content="A Vision of My 30-Year World" />
      </Helmet>

      {/* Main Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-8 lg:gap-12">
          {/* Text Section */}
          <div className="w-full md:w-1/2 space-y-4 md:space-y-6 text-left md:text-left">
            <h1 className="text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-bold text-black leading-tight">
              {slides[currentSlide].title}
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed">
              {slides[currentSlide].text}
            </p>
            <button
              onClick={handleAboutClick}
              className="bg-[#FF6F00] text-white px-6 py-3 text-base sm:text-lg rounded-lg shadow-md hover:bg-[#E65C00] transition-all duration-300 w-full sm:w-auto"
            >
              Let's Connect Now <FaArrowRight className="inline-block ml-2" />
            </button>
          </div>

          {/* Image Section */}
          <div className="w-full md:w-1/2">
            <img
              src={slides[currentSlide].image}
              alt="Business Growth"
              className="w-full max-w-[350px] md:max-w-[600px] mx-auto rounded-xl  transform hover:scale-105 transition-transform duration-300"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
